const SiteLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="100" height="100">
    <g fill="none" fillRule="evenodd">
      <path
        className="fill-primary"
        fill="#264165"
        d="M100.5 524.9c-4.6-3.6 170.2-55.7 179.6-63.6 9.5-7.8 439.4-33.5 439.4-33.5s165.1 10.5 157.7 22c-7.4 11.5-139.1 186.7-139.1 186.7s72.2 133.9 75.2 156.6c3 22.7 39.4 130.6 35 135-27.2 37.7-599.2 68.2-673.5 4.2 0 0 95-282.4 138.8-298.7 0 0-145.7-121.7-213-108.7Z"
      />
      <path
        className="fill-background"
        fill="#FFF"
        d="M440.8 932.5c-12-29.6-134-172.1-179.6-195.3 0 0 74.6-63.7 86.2-64.2 0 0 2.6-11.3-32.2-43.7-34.8-32.5-144-101-173.1-104.2 0 0-2.2-2.7 3.4-3.3 5.6-.7 185.4 75 217.2 160.3l-62.3 49.1s156 197.4 140.4 201.3Zm46.9-31.5C495.8 885.5 668 723.5 688 729.5l-87.5-51.3c-2.7-1.6-9.8 4.7-4.9 8.4s66.5 47.8 75.4 46.8c0 0-13.7 4-25.7 10.9-12.1 7-164 138.8-157.7 156.5Z"
      />
      <path
        className="fill-background"
        fill="#FFF"
        d="M451.3 950.7S507.7 846.3 545 757c37.4-89.3 103.9-181 109.2-185 51-59.7 160.9-105.5 222.3-114.6 0 0 4.7-3 4-5.3-.8-2.3-4.6-3-12.7-3s-96.3 24.7-102.9 27.6c-6.6 2.8-96.2 54.5-110.7 68.6-14.6 14.1-71 111.8-77 111-6-.7 3.6-116.7 3.6-116.7l-217.6-24.1 6.2 58.5s9.4 87.6 14.7 109.2l67 267.6Z"
      />
      <path
        className="fill-primary"
        fill="#264165"
        d="m449.5 947.8 55-143.8-21.8-144 21.5-26.5s25.7 48 27.6 48.7c1.8.6-13.8-41.3-19.6-48.8-5.7-7.5-13.2-19.1-13.2-27.3v-36.8l-42.3-3.9 1 25.5-8.4 29.3-22 38.2s-5.4 14-5.4 17 13.1-19.2 13.1-19.2l10.7-21.1 18.6 27.3-40 241.8 25.2 43.6ZM252.6 409.2S6.1 447 19.1 404.8s266.5-157.5 266.5-157.5 27-149 33.1-161.5c6-12.4 35-21.2 55.8-21.2 20.7 0 92 9.3 103.2 8.2 11.1-1 110.2-24.3 130-15.9 19.8 8.5 65.8 128.8 65.8 128.8s288.5 9.6 309 37.3c8.1 11.1-104.6 63.5-245.8 97.9-141.1 34.4-484 88.3-484 88.3Z"
      />
      <path
        className="fill-background"
        fill="#FFF"
        d="M238.3 286.4A226.4 226.4 0 0 0 231 343c0 134.2 124.5 258 259.5 258S750 477.2 750 343c0-26.7-5-53-13.9-78l-497.8 21.4Z"
      />
      <path
        className="fill-primary"
        fill="#264165"
        d="M252.8 285.8A243.8 243.8 0 0 0 490.5 586c135 0 244.5-108.8 244.5-243 0-27-4.4-53-12.7-77.4l-469.5 20.2Z"
      />
      <path
        className="fill-background"
        fill="#FFF"
        d="M281 341.1s57.3 132 173.3 36c0 0-3-23.3-15.7-29.6 0 0-76 68.8-121.5-18.2l-36 11.8ZM468.1 373l14.7-28.1s123 77 138.7-75l49.4-10.3C692.4 322.8 609.4 486.4 468 373Z"
      />
      <path
        className="fill-primary"
        fill="#264165"
        d="M19.1 404.8c13-42.1 266.5-157.5 266.5-157.5s27-149 33.1-161.5c6-12.4 35-21.2 55.8-21.2 20.7 0 92 9.3 103.2 8.2 11.1-1 110.2-24.3 130-15.9 19.8 8.5 65.8 128.8 65.8 128.8s288.5 9.6 309 37.3C990.6 234.1 6 447 19 404.8Z"
      />
      <path
        className="fill-background"
        fill="#FFF"
        d="M343.4 111.2s9 16.6 15 18.8c5.8 2.2 8.6 1.1 25.1 0 16.6-1.1 62-19 66-22 4-2.9 108.4-44.1 137.5-46.4.4 0-14.8-1-20.8-.3-6.1.8-64.5 10-108.4 24.7-44 14.8-65.7 34.7-81.2 32.2s-19.2-9.3-13.8-37.9c0-1-29.9 2.2-34.2 14 0 1.5 14.8 17 14.8 17ZM311 182.7c20.3-15.7 297-51.7 323-41.6 0 0 24.4 46.3 23.4 51.1-15 0-328 30.8-352.5 49.4-1.2 1 6-58.9 6-58.9ZM47 404.2C47 401 242.3 334 474.7 287c94.7-19.1 206.3-42.4 291.9-52.2 31-3.6 78.2-9 111.1-10.5 33-1.6 95.1-1.9 95.1 0s-79 2-196.9 19c-118 17-200 37-301.2 55.9C237 343.5 47 407.3 47 404.2Z"
      />
    </g>
  </svg>
);

export default SiteLogo;
